import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    ViewEncapsulation
} from '@angular/core';
import { modalAnimations } from '@shared/animations/animations';
@Component({
    selector: 'app-validation-modal-component',
    templateUrl: './validation-modal.component.html',
    styleUrls: ['validation-modal.component.scss'],
    animations: modalAnimations,
    encapsulation: ViewEncapsulation.None
})
export class ValidationModalComponent implements OnInit {
    @Input() modalTitle: string;
    @Input() content: string;
    @Input() complexContent: string;
    @Input() buttonLeft = 'global.button.cancel';
    @Input() buttonRight = 'global.button.confirm';
    @Input() showRightButton = true;
    @Input() showLeftButton = true;
    @Input() showInfoIcon = true;
    @Input() visibility: boolean;
    @Input() specificIconBlock: string;
    @Output() leftClick = new EventEmitter<boolean>();
    @Output() rightClick = new EventEmitter<boolean>();
    @Output() crossClick = new EventEmitter<boolean>();
    ngOnInit(): void {}
    buttonLeftClick() {
        this.leftClick.emit(true);
    }
    buttonRightClick() {
        this.rightClick.emit(true);
    }
    buttonCrossClick() {
        this.crossClick.emit(true);
    }
}
